import clone from 'lodash/cloneDeep';
import initialState from '../../store/initialState';
import {
  ADD_MOBILE_TOWER_STARTING,
  ADD_MOBILE_TOWER_SUCCESS,
  ADD_MOBILE_TOWER_ERROR,
} from '../../constants/actionTypes';

export default function addMobileTowerReducer(state = initialState.addMobileTower, action) {
  switch (action.type) {
    case ADD_MOBILE_TOWER_STARTING: {
      const newState = clone(state);
      newState.saving = true;
      newState.saved = false;
      return newState;
    }

    case ADD_MOBILE_TOWER_SUCCESS: {
      const { data } = action;

      const newState = clone(state);
      newState.saving = false;
      newState.saved = true;
      newState.error = null;

      newState.newMobileTower = data.mobileTower;
      return newState;
    }

    case ADD_MOBILE_TOWER_ERROR: {
      const newState = clone(state);
      newState.saving = false;
      newState.saved = false;
      newState.error = action.err;
      return newState;
    }

    default: {
      return state;
    }
  }
}
